import { useEffect, useState } from 'react';

// ----------------------------------------------------------------------

// Demo content from src/_mock/web, fetched on demand.
//
// A static import put faker and the whole generated dataset into the bundle that
// every visitor downloads, for content that is only ever shown when a real
// endpoint has failed. Pass `when` (false while a request is in flight) so the
// chunk is only requested once there is genuinely nothing to show.
//
// Returns `[data, ready]`; `ready` flips once the attempt has settled, so a
// caller can hold its loading state instead of flashing an empty section.
export default function useLazyMockWeb(key, when = true) {
  const [data, setData] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!when) {
      return undefined;
    }

    let active = true;

    import('../_mock/web')
      .then((module) => {
        if (active) {
          setData(module[key] ?? []);
        }
      })
      .catch(() => {
        // Demo data is optional; a failed chunk must not break the section.
      })
      .finally(() => {
        if (active) {
          setReady(true);
        }
      });

    return () => {
      active = false;
    };
  }, [key, when]);

  return [data, ready];
}